import { ModalErrorMessage } from "@/app/error"
import { NftsToSellScopeProvider } from "@/app/nft/sell/selection/scope-provider"
import {
  Dialog,
  DialogContent,
  DialogDescription,
} from "@rarible_int/anaconda_ui_components"
import { Suspense, memo } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { SellDialogContent } from "./dialog-content"

interface Props {
  onOpenChange: (open: boolean) => void
  open: boolean
  isMultiple?: boolean
}

export const SellDialog = memo(function SellDialog({
  onOpenChange,
  open,
  isMultiple,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[396px]"
        aria-describedby="sell-dialog-trigger"
      >
        <NftsToSellScopeProvider>
          <ErrorBoundary fallback={<ModalErrorMessage />}>
            <Suspense fallback={null}>
              <SellDialogContent isMultiple={isMultiple} />
            </Suspense>
          </ErrorBoundary>
        </NftsToSellScopeProvider>
      </DialogContent>
    </Dialog>
  )
})
